import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef } from 'react';
import { onExecuteKeyDown } from '../../utils/KeyboardUtil.js';
import { VisuallyHidden } from '@chakra-ui/react';
import { useCardEffects } from './hooks/use-card-effects.js';
import { CardContainer } from './elements/card-container.js';
import { LegacyCardContainer } from './legacy-elements/legacy-card-container.js';
import { Card } from '../../core/components/Card/card.js';
import { Typography } from '../../core/components/Typography/component.js';
var PresentationCard = function PresentationCard(props) {
  var _props$styleConfig;
  var isChildCard = props.isChildCard,
    _props$noLeftMargin = props.noLeftMargin,
    noLeftMargin = _props$noLeftMargin === void 0 ? false : _props$noLeftMargin,
    srOnlyText = props.srOnlyText,
    _props$type = props.type,
    type = _props$type === void 0 ? 'wide' : _props$type;
  var chakraEnabled = props.chakra !== 'off';
  var cardRef = useRef(null);
  var _useCardEffects = useCardEffects(props, cardRef),
    cardEffects = _useCardEffects.cardEffects;
  var onClick = function onClick(e) {
    var onClick = props.onClick;
    if (typeof onClick === 'function') {
      e.preventDefault();
      e.stopPropagation();
      return onClick();
    }
  };

  // TODO figure out where these should live
  var widths = {
    'extra-wide': '100%',
    wide: '100%',
    medium: '100%',
    narrow: '360px',
    mini: '360px'
  };
  return chakraEnabled ? /*#__PURE__*/React.createElement(Card, _extends({
    variant: ((_props$styleConfig = props.styleConfig) === null || _props$styleConfig === void 0 ? void 0 : _props$styleConfig.shadow) === 'none' ? 'outline' : 'elevated',
    height: cardEffects.showChildren ? '100%' : 'auto',
    maxW: widths[type],
    minW: type === 'mini' || isChildCard ? 'none' : widths[type],
    cursor: cardEffects.hasOnClick ? 'pointer' : 'auto',
    marginTop: "sm",
    marginRight: "sm",
    marginBottom: "sm",
    marginLeft: noLeftMargin ? '0' : 'sm'
  }, props.enableOverflowY && {
    overflowY: 'visible'
  }, cardEffects.dataAttributes, {
    onClick: onClick
  }), srOnlyText && /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(Typography, null, srOnlyText)), /*#__PURE__*/React.createElement(CardContainer, {
    cardProps: props,
    cardEffects: cardEffects
  })) : /*#__PURE__*/React.createElement("div", _extends({}, cardEffects.dataAttributes, {
    className: cardEffects.cardClasses,
    tabIndex: cardEffects.tabIndex,
    onClick: onClick,
    onKeyDown: cardEffects.hasOnClick ? onExecuteKeyDown(onClick) : undefined,
    ref: cardRef
  }), srOnlyText && /*#__PURE__*/React.createElement("h2", {
    className: "sr-only"
  }, srOnlyText), /*#__PURE__*/React.createElement(LegacyCardContainer, {
    cardProps: props,
    cardEffects: cardEffects
  }));
};
export { PresentationCard };